module.exports = __webpack_public_path__ + "img/notFound.24a3fd5b.svg";